export const EQ = 'EQ';
export const LTE = 'LTE';
export const GTE = 'GTE';
